var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.28 6.97a.75.75 0 0 1 0 1.06l-8.844 8.845a1.5 1.5 0 0 1-2.122 0L4.72 13.28a.75.75 0 1 1 1.06-1.06l3.595 3.594L18.22 6.97a.75.75 0 0 1 1.06 0Z"
  })));
};
export default SvgCheck;